import { Action } from "@ngrx/store";
import { toLower } from "lodash-es";

import { CONTEXT_REGEX, SYNC_SUFFIX } from "./fetch-status.const";
import { FetchState, FetchStatusType } from "./fetch-status.model";

const actionRegex = /(.+)(?:\s+)(success|fail|sync)$/i;

const INITIAL_STATE: FetchState = {};

export function fetchStatusReducer(state = INITIAL_STATE, action: Action) {
	const contextRegexResult = CONTEXT_REGEX.exec(action.type);

	if (!contextRegexResult) {
		return state;
	}

	const context = contextRegexResult[0];
	const actionRegexResult = actionRegex.exec(action.type) || undefined;
	const statusType = actionRegexResult && actionRegexResult[2];

	if (statusType === SYNC_SUFFIX) {
		return state;
	}

	let newStatus = FetchStatusType.Loading;
	if (actionRegexResult) {
		newStatus = toLower(statusType) === FetchStatusType.Fail ? FetchStatusType.Fail : FetchStatusType.Success;
	}

	const actionType = (actionRegexResult && actionRegexResult[1]) || action.type;

	if (state[context] && state[context][actionType] === newStatus) {
		return state;
	}

	return {
		...state,
		[context]: {
			...state[context],
			[actionType]: newStatus,
		},
	};
}
